import { useEffect } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import { LocalStorage } from '@/constants';
import { setAuthToken, removeAuthToken } from '@/utils/auth-token';
import { captureException } from '@/utils/capture-exception';

export const SsoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      navigate('/', { replace: true });
      return;
    }

    const handleSsoLogin = async () => {
      try {
        setAuthToken(token);

        const redirectAfterLogin = localStorage.getItem(
          LocalStorage.RedirectAfterLogin
        );

        if (redirectAfterLogin) {
          localStorage.removeItem(LocalStorage.RedirectAfterLogin);
          window.location.href = redirectAfterLogin;
          return;
        }

        navigate('/', { replace: true });
      } catch (error) {
        removeAuthToken();
        navigate('/login?ssoError=true', { replace: true });
        captureException({ error });
      }
    };

    handleSsoLogin();
  }, [searchParams, navigate]);

  return (
    <Stack
      height="100vh"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <CircularProgress size={40} />
    </Stack>
  );
};
